<template>
  <div class="wrap" >
    <div class="info-image" :class="classObject"></div>
    <p class="info-text">{{stateText}}</p>
    <div class="info-button" v-if="showResearchBtn" v-tap.prevent="{ methods : reSearch }">{{researchBtnTxt}}</div>
  </div>
</template>
<script>
  import enums from '../../enums/index.js'
  export default {
    data(){
      return {
        showResearchBtn: 0,
        researchBtnTxt: '重新查询',
        classObject: {}
      }
    },
    props: {
      state: {
        type: [String, Number],
        default: '默认'
      }
    },
    computed: {
//      classObject: function(){
//        return this
//      },
      stateText: function(){
        const state = this.state;
        let result = ' ';
        switch(state){
          case enums.ajaxState.working:
            result = enums.tips.search_working;
            break;
          case enums.ajaxState.success:
            result = enums.tips.search_success;
            break;
          case enums.ajaxState.failed:
            result = enums.tips.search_failed
            break;
          case enums.ajaxState.error:
            result = enums.tips.search_failed
            break;
          case enums.ajaxState.badnetwork:
            result = enums.tips.bad_network;
            break;
          case enums.ajaxState.pageConfigSuccess:
            result = enums.tips.page_config_success;
            break;
          default:
            break;
        }
        return result;
      }
    },
    watch: {
      state(val){
        this.stateChange(val)
      }
    },
    methods: {
      reSearch: function(){
        this.$emit('reSearch');
        if(this.state == enums.ajaxState.pageConfigSuccess){
          location.reload();
        }
      },
      stateChange(val){
        this.classObject = {
          'searching': val == enums.ajaxState.working,
          'search_success': val == enums.ajaxState.success || val == enums.ajaxState.pageConfigSuccess,
          'search_failed': val == enums.ajaxState.failed || val == enums.ajaxState.error,
          'bad_network': val == enums.ajaxState.badnetwork
        }
        this.showResearchBtn = val == enums.ajaxState.failed || val == enums.ajaxState.error || val == enums.ajaxState.badnetwork || val == enums.ajaxState.pageConfigSuccess;
        if(val == enums.ajaxState.pageConfigSuccess){
          this.researchBtnTxt = '确定'
        }else{
          this.researchBtnTxt = '重新查询'
        }
      }
    },
    created(){
      this.stateChange(this.state);
    }
  }
</script>

<style lang='less' scoped>
  @import '../../assets/less/base.less';
  .wrap{
    position:absolute;
    left:0;
    right:0;
    top:0;
    bottom:0;
    z-index: 0;
    margin:auto;
    font-size: @font-size-larger;
    width:840px;
    height:380px;
    padding: 28px 0;
    background:#fff;
    .card-shadow;
  }
  .info-image{
    height: 220px;
    background: center center no-repeat;
    background-size: contain;
  }
  .searching{background-image: url('../../../static/ajax-working.png');}
  .search_success{background-image: url('../../../static/ajax-success.png');}
  .search_failed{background-image: url('../../../static/ajax-failed.png');}
  .bad_network{background-image: url('../../../static/bad-network.png');}
  .info-text{text-align:center;font-size: @font-size-normal;color: #333;margin: 12px 0;}
  .info-button{width: 370px;margin: 0 auto;height: 60px;line-height: 60px;text-align:center;font-size: @font-size-normal;background:@color-orange;color:@color-white;border-radius: 50px;}
</style>



// WEBPACK FOOTER //
// searchState.vue?5cecda06